import React, { Component } from 'react';
import Slider from "react-slick";
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import './css/DealerCustomerCard.css';
import $ from 'jquery';

class DealerCustomerCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }
    componentDidMount(){
        $(".quick-btn").click(function(){
            $(".quick-btn").removeClass("active");
            $(this).addClass("active");
        });
    }
    render() {
        let setting = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 4,
            initialSlide: 0,
            responsive: [
                            {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                                infinite: true,
                                dots: true
                            }
                            },
                            {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                                initialSlide: 2
                            }
                            },
                            {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                            }
                        ]
          };
        return (
            <div className="DCCrad">

            <Slider {...setting}>
                <a className="quick-btn active" href="#">
                     <i className="fab fa-creative-commons-nd fa-2x " /><br />
                     <span style={{ fontSize: 12 }}> ทั้งหมด</span>
                     <span className="badge badge-warning">19,027</span>
                 </a>
                 <a className="quick-btn" href="#">
                     <i className="fas fa-diagnoses fa-2x " /><br />
                     <span style={{ fontSize: 12 }}> ลูกค้า</span>
                     <span className="badge badge-warning">10,435</span>
                 </a>
                 <a className="quick-btn" href="#">
                     <i className="fa fa-handshake-o fa-2x " /><br />
                     <span style={{ fontSize: 12 }}> บ. GPS Tracking</span>
                     <span className="badge badge-warning">1,027</span>
                 </a>
                 <a className="quick-btn" href="#">
                     <i className="fa fa-handshake-o fa-2x " /><br />
                     <span style={{ fontSize: 12 }}> บริษัท จีพีเอสไทยสตาร์</span>
                     <span className="badge badge-warning">985</span>
                 </a>
                 <a className="quick-btn" href="#">
                     <i className="fa fa-handshake-o fa-2x " /><br />
                     <span style={{ fontSize: 12 }}> BestTech</span>
                     <span className="badge badge-warning">789</span>
                 </a>
                 <a className="quick-btn" href="#">
                 <i className="fa fa-handshake-o fa-2x " /><br />
                     <span style={{ fontSize: 12 }}> บริษัท GPSTECH</span>
                     <span className="badge badge-warning">500</span>
                 </a>
                 <a className="quick-btn" href="#">
                 <i className="fa fa-handshake-o fa-2x " /><br />
                     <span style={{ fontSize: 12 }}> จีพีเอสไอแอม</span>
                     <span className="badge badge-warning">435</span>
                 </a>
                 
             
            </Slider>
            </div>
            // <div>
            //     <a className="quick-btn" href="#">
            //         <i className="fa fa-handshake-o fa-2x " /><br />
            //         <span style={{ fontSize: 12 }}> บ. GPS Tracking</span>
            //         <span className="badge badge-warning">1,027</span>
            //     </a>
            //     <a className="quick-btn" href="#">
            //         <i className="fa fa-handshake-o fa-2x " /><br />
            //         <span style={{ fontSize: 12 }}> บริษัท จีพีเอสไทยสตาร์</span>
            //         <span className="badge badge-warning">985</span>
            //     </a>
            //     <a className="quick-btn" href="#">
            //         <i className="fa fa-handshake-o fa-2x " /><br />
            //         <span style={{ fontSize: 12 }}> BestTech</span>
            //         <span className="badge badge-warning">789</span>
            //     </a>
            //     <a className="quick-btn" href="#">
            //     <i className="fa fa-handshake-o fa-2x " /><br />
            //         <span style={{ fontSize: 12 }}> บริษัท GPSTECH</span>
            //         <span className="badge badge-warning">500</span>
            //     </a>
            //     <a className="quick-btn" href="#">
            //     <i className="fa fa-handshake-o fa-2x " /><br />
            //         <span style={{ fontSize: 12 }}> จีพีเอสไอแอม</span>
            //         <span className="badge badge-warning">435</span>
            //     </a>
            // </div>
        );
    }
}
export default DealerCustomerCard;


// WEBPACK FOOTER //
// ./src/app/view/components/Monitor/DealerCustomerCard/DealerCustomerCard.js